import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import './Footer.css';
import PropTypes from 'prop-types';
import IconsList from '../IconsList/IconsList';
import Newsletter from '../Newsletter/Newsletter';
import SocialMediaButtons from '../SocialMediaButtons/SocialMediaButtons';

const Footer = (props) => {
  const { isSubPage } = props;

  const prepareRows = (rows) => {
    const result = rows.reduce(
      ([bottomRows, topRows], row) => {
        return row.isBottom ? [[...bottomRows, row], topRows] : [bottomRows, [...topRows, row]];
      },
      [[], []]
    );

    isSubPage && result[1].pop();
    return result;
  };

  return (
    <StaticQuery
      query={graphql`
        query {
          footerItems: allContentfulFooterItem(sort: { order: ASC }) {
            nodes {
              id
              order
              category
              isBottom
              items {
                ... on ContentfulLink {
                  id
                  url
                  text
                }
                ... on ContentfulTitleAndText {
                  id
                  text
                  title
                }
                ... on ContentfulText {
                  id
                  title
                }
              }
            }
          }
        }
      `}
      render={(data) => {
        const rows = prepareRows(data.footerItems.nodes);
        const topRows = rows[1];
        const bottomRows = rows[0];

        return (
          <footer className="footer">
            <div className={`${isSubPage ? 'sl__container sl-pad-large' : 'container'}`}>
              <div className="row footer__row first__row">
                {/* Top Row */}
                {topRows.map(({ id, category, items, order }, index) => (
                  <React.Fragment key={id}>
                    <div className="column row__top footer__column">
                      {index !== 0 && index !== 2 && (
                        <h1 className="footer__first__row__title">{category}</h1>
                      )}
                      <div className="footer__list">
                        {items &&
                          items.map((item) => {
                            switch (order) {
                              case 1:
                                return null;
                              case 2:
                                return <SocialMediaButtons key={item.id} />;
                              case 3:
                                return (
                                  // <Newsletter
                                  //   key={item.id}
                                  //   footnote={item.title}
                                  // />
                                  <p></p>
                                );
                              default:
                                return (
                                  <button
                                    type="button"
                                    key={item.id}
                                    onClick={() => window.open(item.url)}
                                  >
                                    {item.text}
                                  </button>
                                );
                            }
                          })}
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
              {/* Bottom Row */}
              <div className="row footer__row">
                {bottomRows.map(({ id, category, items }) => (
                  <React.Fragment key={id}>
                    <div className="column row__bottom footer__column">
                      <h1 className="footer__title">{category}</h1>
                      <div className="footer__list">
                        {items ? (
                          items.map((item) => (
                            <div key={item.id} className="footer__list__item">
                              <a href={item.url}>{item.text}</a>
                            </div>
                          ))
                        ) : (
                          <IconsList iconsType="payment" />
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
              <p className="footer__credits">{`© ${new Date().getFullYear()} LykonDX GmbH`}</p>
            </div>
          </footer>
        );
      }}
    />
  );
};

Footer.propTypes = {
  isSubPage: PropTypes.bool.isRequired,
};

export default Footer;
